import * as React from 'react';
export const IcCloudOff = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14 5a6 6 0 00-5.2 3 4 4 0 00-3.31 2.1A4.5 4.5 0 002 14.5a4.42 4.42 0 00.77 2.5L14.71 5.05A5.517 5.517 0 0014 5zm6 6.54c.01-.18.01-.36 0-.54a6 6 0 00-1.55-4l2-2a1.038 1.038 0 00-.314-1.7A1.04 1.04 0 0019 3.51L3.51 19A1.054 1.054 0 105 20.49L6.44 19H18a4 4 0 002-7.46z'
      fill='currentColor'
    />
  </svg>
);
